import { render, staticRenderFns } from "./ExperienceHomeNewPhone.vue?vue&type=template&id=648e02cd&scoped=true&"
import script from "./ExperienceHomeNewPhone.vue?vue&type=script&lang=js&"
export * from "./ExperienceHomeNewPhone.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceHomeNewPhone.vue?vue&type=style&index=0&id=648e02cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e02cd",
  null
  
)

export default component.exports